// extracted by mini-css-extract-plugin
export default {"wrapper":"gr-z","response":"hr-z","error":"ir-z","disabled":"jr-z","buttons":"kr-z","feedbackQuestionSection":"lr-z","yesNoWrapper":"mr-z"};